import colors from 'assets/theme/base/colors';
import pxToRem from 'assets/theme/function/px-to-rem';
import rgba from 'assets/theme/function/rgba';
import borders from 'assets/theme/base/borders';
import typography from 'assets/theme/base/typography';
import { breakpoints } from 'assets/theme/base/breakpoints';

const { common, primary, error } = colors;
const { borderRadius } = borders;
const { fontWeightRegular, size } = typography;

const inputOutlined = {
    styleOverrides: {
        root: {
            //backgroundColor: rgba(primary.main, 0.05),
            color: common.white,
            borderColor: primary.main,
            borderRadius: borderRadius.md,
            fontSize: size.md,
            fontWeight: fontWeightRegular,
            caretColor: common.white,

            [breakpoints.down('md')]: {
                fontSize: size.sm,
            },

            [breakpoints.down('sm')]: {
                fontSize: size.xs,
            },

            '&:hover, &.Mui-focused': {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: primary.main,
                },
            },

            '&.Mui-error': {
                '&:hover, &.Mui-focused': {
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: error.light,
                    },
                },
            },

            '&.Mui-disabled': {
                '& .MuiOutlinedInput-input': {
                    WebkitTextFillColor: rgba(primary.main, 0.3),
                },

                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: rgba(primary.main, 0.3),
                },
            },
        },

        notchedOutline: {
            borderColor: primary.main,
        },

        input: {
            padding: `${pxToRem(13)} ${pxToRem(16)}`,
            WebkitTextFillColor: common.white,
            WebkitBackgroundClip: 'text',
            //WebkitBoxShadow: 'none',

            [breakpoints.down('sm')]: {
                padding: `${pxToRem(14)} ${pxToRem(14)}`,
            },
        },

        colorSecondary: {
            //backgroundColor: action.menu,

            '& .MuiOutlinedInput-input': {
                color: common.white,
                WebkitTextFillColor: common.white,
            },
        },

        inputSizeSmall: {
            //fontSize: size.xs,
            // padding: pxToRem(10),
        },

        multiline: {
            //color: grey[700],
            //padding: 0,
        },
    },
};

export default inputOutlined;
